function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "components/user_pic_add");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
  id: "path-1",
  cx: 30,
  cy: 30,
  r: 30
}));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  id: "components/user_pic_add",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "camera",
  transform: "translate(14.583333, 16.750000)",
  stroke: "#D8D8D8",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3
}, /*#__PURE__*/React.createElement("path", {
  d: "M34.8333333,25.3333333 C34.8333333,27.082235 33.4155684,28.5 31.6666667,28.5 L3.16666667,28.5 C1.41776496,28.5 0,27.082235 0,25.3333333 L0,7.91666667 C0,6.16776496 1.41776496,4.75 3.16666667,4.75 L9.5,4.75 L12.6666667,0 L22.1666667,0 L25.3333333,4.75 L31.6666667,4.75 C33.4155684,4.75 34.8333333,6.16776496 34.8333333,7.91666667 L34.8333333,25.3333333 Z",
  id: "Shape"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  cx: 17.4166667,
  cy: 15.8333333,
  r: 6.33333333
})), /*#__PURE__*/React.createElement("g", {
  id: "Icon-/-5",
  transform: "translate(2.000000, 2.000000)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-2",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-1"
})), /*#__PURE__*/React.createElement("use", {
  id: "Mask",
  stroke: "#D8D8D8",
  strokeWidth: 3,
  xlinkHref: "#path-1"
})));

var SvgUserPicAdd = function SvgUserPicAdd(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "64px",
    viewBox: "0 0 64 64",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUserPicAdd, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/user-pic-add.940b6962.svg";
export { ForwardRef as ReactComponent };